import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { MenuProvider } from "@voicecare.ai/ui-library";
import "./beacon-style.css";
import * as Sentry from "@sentry/react";
import DOMPurify from "dompurify";
import { AccountProvider } from "./context/AccountContext";
import { AuthProvider } from "./context/AuthContext";

// Security Headers Fallback - Add programmatic security headers if not set by server
const addSecurityHeaders = () => {
  // Check if CSP meta tag exists, if not add it programmatically
  if (!document.querySelector('meta[http-equiv="Content-Security-Policy"]')) {
    const cspMeta = document.createElement('meta');
    cspMeta.httpEquiv = 'Content-Security-Policy';
    cspMeta.content = `
      default-src 'self'; 
      script-src 'self' https://cdn.jsdelivr.net https://api.stripe.com https://apis.google.com; 
      style-src 'self' 'unsafe-inline'; 
      img-src 'self' data: https://purecatamphetamine.github.io; 
      font-src 'self'; 
      connect-src 'self' https://identitytoolkit.googleapis.com https://accounts.google.com/gsi/client https://js.stripe.com https://securetoken.googleapis.com/v1/token https://storage.googleapis.com https://storage.cloud.google.com https://dev-customer-ui-803797777586.us-central1.run.app https://qa-customer-ui-894714350548.us-central1.run.app https://prod-customer-ui-907496619557.us-central1.run.app https://customer.voicecare.ai https://devkong.voicecare.ai https://devkong.voicecare.ai/customer-ui-auth/ https://devkong.voicecare.ai/customer-ui-ms/ https://34.54.79.89.nip.io https://34.49.73.143.nip.io https://*.sentry.io; 
      frame-ancestors 'none'; 
      form-action 'self'; 
      base-uri 'self';
      object-src 'none';
      media-src 'self' https://storage.googleapis.com https://storage.cloud.google.com;
      upgrade-insecure-requests;
    `;
    document.head.appendChild(cspMeta);
  }

  // Add X-Frame-Options if not present
  if (!document.querySelector('meta[http-equiv="X-Frame-Options"]')) {
    const frameMeta = document.createElement('meta');
    frameMeta.httpEquiv = 'X-Frame-Options';
    frameMeta.content = 'DENY';
    document.head.appendChild(frameMeta);
  }
};

// if (window.trustedTypes && window.trustedTypes.createPolicy) {
//   window.trustedTypes.createPolicy('myPolicy', {
//     createHTML: (input) => DOMPurify.sanitize(input, { RETURN_TRUSTED_TYPE: true }),
//     createScript: (input) => input,
//     createScriptURL: (input) => input,
//   });
// }

if (window.trustedTypes && window.trustedTypes.createPolicy) {
  try {
    window.trustedTypes.createPolicy("default", {
      createHTML: (input) =>
        DOMPurify.sanitize(input, { RETURN_TRUSTED_TYPE: true }),
      createScript: (input) => input,
      createScriptURL: (input) => input,
    });
  } catch (error) {
    console.warn(
      'Trusted Types policy "default" already exists or an error occurred:',
      error
    );
  }
}


// Initialize security headers - DISABLED: Using CSP from App.js instead
// addSecurityHeaders();

Sentry.init({
  dsn: process.env.REACT_APP_CSP_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <MenuProvider>
      <AuthProvider>
        <AccountProvider>
          <App />
        </AccountProvider>
      </AuthProvider>
    </MenuProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals())
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
